/**
 * Consolidates paths and routing into one place
 * @See App.jsx
 * @See {Route} from react-router-dom
 */
import FaqView from 'views/faq-view';
import EntryView from 'views/entry-view';
import OopsView from 'views/oops-view';
import Expired from './views/expired-view';
import OrderSearchView from './views/order-search-view';

const Routes = {
  orderSearch: {
    key: 'orderSearch',
    path: '/orders',
    component: OrderSearchView,
  },
  main: {
    key: 'main',
    path: '/:guid',
    component: EntryView,
  },
  faq: {
    key: 'faq',
    path: '/faq',
    component: FaqView,
  },
  oops: {
    key: 'oops',
    path: '/error',
    component: OopsView,
  },
  expired: {
    key: 'expired',
    path: '/expired',
    component: Expired,
  },
};

export default Routes;
